import { FC, ReactNode } from 'react'

import Icon, { IconTypes } from '~ui/Icon'
import Wrapper from '../wrapper'

import styles from './template.module.scss'

interface TemplateProps {
  classNames?: string
  iconName?: IconTypes
  title?: string
  children?: ReactNode
}

const Template: FC<TemplateProps> = ({ iconName, title, children, classNames }) => (
  <Wrapper className={classNames}>
    {title && (
      <span className={styles.title}>
        {iconName && <Icon name={iconName} width="1em" height="1em" fill="currentColor" />}
        {title}
      </span>
    )}
    {children}
  </Wrapper>
)

export default Template
